import * as actionTypes from "./actionTypes";

export const onChangeNotification = (param) => {
  return {
    param,
    type: actionTypes.MANAGE_NOTIFICATION,
  };
};

